import React, { Component } from 'react';
import Swal from 'sweetalert2';
import NavBar from '../navbar.js';
import Footer from '../footer.js';
import { properties } from '../properties.js';
import UserCertificateDisplay from '../UserCertificateDisplay.js';
import Cookies from 'js-cookie';
import i18n from '../I18N/I18n.js'; 
import { withTranslation } from 'react-i18next';
import '../css/listaEmpresas.css';
import {logout, apiSecuredRequest, isUserOrWallet, isRootWallet, setBearer, cargarIdiomaPreferido} from '../functions.js';



class CertificateList extends Component {
      async componentDidMount() {
                // 1. Carga de Web3
                await cargarIdiomaPreferido(this.cambiarIdioma);
                const { bearerToken, certificadoId } = await this.checkIfWeb3UserOrLoginUser();
               
               
                // 2. Carga de datos de la Blockchain
        
                await this.cargarPasaportesCertificado(bearerToken, 0, certificadoId);
            }
    
            cambiarIdioma = (idioma) => {
                const { i18n } = this.props;
                i18n.changeLanguage(idioma); 
                this.forceUpdate(); 
                 Cookies.set('idiomaPreferido', idioma, { expires: 365 });// Cambia el idioma usando i18n
             };
            
           logout = async () => {
                this.setState({bearer: null});
                this.setState({email: null});
                logout();
            } 
            
            generatePageNumbers = () => {
                const { certificadosTotal, pageSize } = this.state;
                const totalPages = Math.ceil(certificadosTotal / pageSize);
              
                // Por ahora mostramos todos los botones (luego podemos limitarlo si hay muchas páginas)
                return Array.from({ length: totalPages }, (_, i) => i);
            };

            handlePageChange = (newPage) => {
                const { bearer } = this.state;
                this.cargarPasaportesCertificado(bearer, newPage, this.state.certificadoId);
            };

            async checkIfWeb3UserOrLoginUser() { 
                   let params = (new URL(document.location)).searchParams;
                   const certificadoId = params.get("certificadoId");
                   this.setState({ certificadoId })
                   const certificadoName = params.get("certificadoName");
                   this.setState({certificadoName})
                            
                   const standardType = params.get("standardType");
                   this.setState({ standardType: standardType })
                   const email = Cookies.get("email");
                   this.setState({ email: email });
                   const certificado = JSON.parse(localStorage.getItem('certificado'));
                   const usuario = JSON.parse(localStorage.getItem('usuario'));
                   this.setState({userId: usuario.id})
                   const direccion = certificado.direccion;
                   this.setState({direccion: direccion})
                   const bearer = Cookies.get("id");
                   this.setState({ bearer: bearer });
                   const userRol = Cookies.get("rol");
                   this.setState({ userRol: userRol });
                   let bearerVar;
                   const urlInfo = window.location.pathname.split("/")
                         
                   this.setState({ empresaMapping: urlInfo[1] })
                           
                   bearerVar = Cookies.get("id");
                   let account = await isUserOrWallet(email, bearerVar);
                    
                   this.setState({account})
                   const bearerToken = await setBearer(email, bearerVar, account);
                   this.setState({bearer: bearerToken})
                   return {bearerToken, certificadoId};
             }

             async cargarPasaportesCertificado(bearer, page, certificadoId) {
                const { pageSize } = this.state;
              
                const dppsData = JSON.stringify({
                  "certificadoId": `${certificadoId}`,
                  "page": page.toString(),
                  "limit": pageSize.toString()
                });
              
                let certificados;
              
                try {
                  certificados = await apiSecuredRequest(
                    'post',
                    `${properties.apiUrl}/certificat/api/web3jService/getStandard16`,
                    dppsData,
                    bearer
                  );
                } catch (error) {
                  console.error("Error al obtener los campos:", error);
              
                  Swal.fire({
                    title: `${i18n.t('errorOccurred')}`,
                    confirmButtonText: `${i18n.t('continue')}`,
                    confirmButtonColor: '#E94981',
                    icon: 'error',
                    iconColor: '#66C08B',
                    width: '560px',
                  });
              
                  certificados = { data: { total: 0, items: [] } }; // estructura de fallback
                }
              
                this.setState({
                  certificados: certificados.data.items,
                  certificadosTotal: certificados.data.total,
                  currentPage: page
                });
              }

              constructor(props) {
                super(props);
                this.state = {
                    account: "0x0",
                    bearer: null,
                    certificadoName: null,
                    certificadosTotal: 0,
                    currentPage: 0,
                    pageSize: 10,
                    direccion: null,
                    certificadoId: null,
                    userRol: null,
                    userId: null,
                    email: null,
                    empresaMapping: null,
                    standardType: null,
                    isRootDir: null,
                    certificados: null
                };
            }

            render(){

                if (this.state.certificados != null && this.state.certificados.length > 0){
                    return (
                        <>
                       <NavBar mail={this.state.email} bearer={this.state.bearer} logout={this.logout} cambiarIdioma={this.cambiarIdioma} />
                            <div className="empresas-container">
                            <h1>{i18n.t('certificados')}</h1>
                              <div className="empresas-header">
                
                            
                          </div>
                          <button
                  type="button"
                  className="btn"
                  onClick={() => {
                    window.location.href = `/listaEmpresas`;
                  }}
                >
                  {i18n.t('back')}
                </button>
                                <table className="empresas-table">
                                  <UserCertificateDisplay items={this.state.certificados} mapping={this.state.empresaMapping} certificadoId={this.state.certificadoId} />
                                  <div className="pagination-controls">
          <button
            onClick={() => this.handlePageChange(this.state.currentPage - 1)}
            disabled={this.state.currentPage === 0}
          >
            «
          </button>
        
          {this.generatePageNumbers().map((page) => (
            <button
              key={page}
              onClick={() => this.handlePageChange(page)}
              className={page === this.state.currentPage ? 'active-page' : ''}
            >
              {page + 1}
            </button>
          ))}
        
          <button
            onClick={() => this.handlePageChange(this.state.currentPage + 1)}
            disabled={(this.state.currentPage + 1) * this.state.pageSize >= this.state.certificadosTotal}
          >
            »
          </button>
        </div>                       
                                </table>
                               
        
                           </div>    
              
                           <Footer />
                      </>
                    );
                }else{
                    return (
                        <>
                      
              
                       <NavBar mail={this.state.email} bearer={this.state.bearer} logout={this.logout} cambiarIdioma={this.cambiarIdioma} />
                            <div className="empresas-container">
                            <h1>{i18n.t('certificados')}</h1>
                              <div className="empresas-header">
                
                           
                          </div>
                          <h1>{i18n.t('oopsMessage')}</h1>
                           </div>    
              
                        <Footer />
              
                         
                      </>
                    );
                }
            }


}export default withTranslation()(CertificateList);